import React from 'react';
import { Text } from '@hub/text';
import { Stack } from '@hub/stack';
import { Box } from '@hub/box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function hasNoHours(openHourDay) {
  return !openHourDay || !openHourDay.day || !openHourDay.hours;
}
function hasNoDescription(text) {
  return !text || !text.description;
}
const DayText = _ref => {
  let {
    day
  } = _ref;
  return /*#__PURE__*/_jsx(Text, {
    dataTestId: "opening-hours-day",
    "data-id": "trading-hours-line_index_DayText_Text",
    children: day
  });
};
const HoursText = _ref2 => {
  let {
    hours
  } = _ref2;
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      width: 'size-15'
    },
    "data-id": "trading-hours-line_index_DayText_Box",
    children: hours.length > 1 ? /*#__PURE__*/_jsx("span", {
      "data-id": "trading-hours-line_index_DayText_span",
      children: hours.map(hour => /*#__PURE__*/_jsx(Text, {
        dataTestId: "opening-hours-hour",
        "data-id": "trading-hours-line_index_DayText_Text",
        children: hour
      }, hour))
    }) : /*#__PURE__*/_jsx(Text, {
      dataTestId: "opening-hours-hour",
      "data-id": "trading-hours-line_index_DayText_Text_4",
      children: hours
    })
  });
};
const DescriptionText = _ref3 => {
  let {
    text
  } = _ref3;
  return hasNoDescription(text) ? null : /*#__PURE__*/_jsx(Text, {
    sx: {
      marginTop: 'spacing-xs'
    },
    dataTestId: "opening-hours-desc",
    "data-id": "trading-hours-line_index_DayText_Text_5",
    children: text.description
  });
};
const TradingHoursLine = _ref4 => {
  let {
    openHourDay
  } = _ref4;
  if (hasNoHours(openHourDay)) {
    return null;
  }
  const {
    hours,
    day,
    text
  } = openHourDay;
  return /*#__PURE__*/_jsxs(Stack, {
    "data-id": "trading-hours-line_index_DayText_Stack",
    children: [/*#__PURE__*/_jsxs(Box, {
      "data-test-id": "opening-hours-entry",
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        fontWeight: day === 'Today' ? 'medium' : 'normal'
      },
      "data-id": "trading-hours-line_index_DayText_Stack_Box",
      children: [/*#__PURE__*/_jsx(DayText, {
        day: day,
        "data-id": "trading-hours-line_index_Box_DayText"
      }), /*#__PURE__*/_jsx(HoursText, {
        hours: hours,
        "data-id": "trading-hours-line_index_DayText_Box_HoursText"
      })]
    }), /*#__PURE__*/_jsx(DescriptionText, {
      text: text,
      "data-id": "trading-hours-line_index_DayText_Stack_DescriptionText"
    })]
  });
};
export default TradingHoursLine;